import { useBoundStore } from "useStore";
import FilterChip from "./FilterChip";
import { Stack } from "@mui/material";
import { INITIAL_AD_STATE } from "./utils";

export default function AdStateFilterChip() {
  const selectedAdStates = useBoundStore(
    (state) => state.campaignManagerSelectedAdStates,
  );
  const toggleSelectedAdState = useBoundStore(
    (state) => state.toggleCampaignManagerSelectedAdState,
  );

  const isAllSelected = selectedAdStates?.length === INITIAL_AD_STATE.length;

  if (!selectedAdStates || isAllSelected) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {selectedAdStates.map((adState) => (
        <FilterChip
          key={adState}
          filterName="Ad State"
          title={adState}
          onDelete={() => toggleSelectedAdState(adState)}
        />
      ))}
    </Stack>
  );
}
